import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { IAds } from 'src/modules/ads';
import { Category, Datum, SubCategory2 } from 'src/modules/cid';
import { DataContent } from 'src/modules/cid/id';
import { Data } from 'src/modules/sections/section-1';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useMobilePhone } from 'src/utils/device';
import styled from 'styled-components';
import { KEY_ADS_POSITION } from '../ads/dynamicAds';
import WidgetBreadcrumb from '../widgets/widget-breadcrumb';

const DynamicAds = dynamic(import('../ads/dynamicAds'));
const CardV = dynamic(import('src/components/cards/card-v'));
const CardHLG = dynamic(import('src/components/cards/card-h-lg'));
const Carousels = dynamic(import('src/components/carousels'));

type Props = {
  articles: Datum[];
  articlesHighlight: Data;
  acticlesresDataPin: DataContent;
  dataSetPinEmbed: any;
  category: Category;
  subCategory: SubCategory2;
  subMenu: any;
  sliceId: number | any;
  listArticles: Datum[];
  isFetching?: boolean;
  ads?: IAds[];
};

const CategoryVideo = ({ articles, acticlesresDataPin, dataSetPinEmbed, category, subCategory, subMenu, listArticles, sliceId, isFetching, ads }: Props) => {
  const router: any = useRouter();

  const checkDataInsubMenu = () => {
    if (subMenu?.sub) {
      for (let i = 0; i < subMenu?.sub.length; i++) {
        const element = subMenu?.sub[i];
        if (element) {
          return !isEmpty(element.data);
        }
      }
    }
  };

  return (
    <>
      <CategoryWrapper>
        <div className='container'>{/* <SectionHighlight data={articlesHighlight?.newHighlight} unsetBottom={false} ads={ads} /> */}</div>
        <div className='category-detail'>
          <div className='container'>
            {/* Heading */}
            <div className='breadcrumb-area'>
              <WidgetBreadcrumb data={{ category, subCategory }} isCate={true} />
            </div>

            <div id='section-2'>
              {!isEmpty(dataSetPinEmbed) ? (
                <>
                  <a href={acticlesresDataPin?.link}>
                    <h2>{acticlesresDataPin?.title}</h2>
                  </a>
                  <div className='embed-audio' dangerouslySetInnerHTML={{ __html: dataSetPinEmbed }}></div>
                </>
              ) : (
                <>
                  {!isEmpty(acticlesresDataPin) ? (
                    <div className='crad-video-category-item'>
                      {!isEmpty(articles) && (
                        <CardHLG
                          data={acticlesresDataPin}
                          showTitle={true}
                          showBlurb={true}
                          showByline={false}
                          showTime={false}
                          external={false}
                          showCountview={false}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_INDEX,
                            router: router?.pathname,
                            section: 'section-2',
                            data: {
                              title: acticlesresDataPin?.title,
                              heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                              index: 1
                            }
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <>
                      <div className='meta-data'>
                        <h1 className='category m-0'>{subCategory?.en ? subCategory?.en : 'watch'}</h1>
                        <h2 className='category m-0'>{subCategory?.en ? subCategory?.en : 'watch'}</h2>
                      </div>
                      {!isEmpty(articles) && (
                        <div className='crad-video-category-item'>
                          {!isEmpty(articles) && (
                            <CardHLG
                              data={articles[0]}
                              showTitle={true}
                              showBlurb={true}
                              showByline={false}
                              showTime={false}
                              external={false}
                              showCountview={false}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_INDEX,
                                router: router?.pathname,
                                section: 'section-2',
                                data: {
                                  title: articles[0]?.title,
                                  heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                                  index: 1
                                }
                              }}
                            />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
            {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}
            {isEmpty(router?.query?.sub) ? (
              <>
                {!isEmpty(subMenu?.sub) && (
                  <>
                    <ul className='submenu-list' id='section-3'>
                      {subMenu?.sub?.map((item: any, i: any) => (
                        <>
                          {!isEmpty(item.data) && (
                            <li key={i}>
                              {!isEmpty(item.data.filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))) && (
                                <div className='title-left'>
                                  <a href={`${item.link}`} title={item.nameEng}>
                                    <h2 className={'active'}>{item?.nameEng}</h2>
                                  </a>
                                  <a href={`${item.link}`} title={item.nameEng}>
                                    <p className={'active text-left'}>ดูทั้งหมด</p>
                                  </a>
                                </div>
                              )}

                              <div className='row category-list'>
                                {useMobilePhone() && (
                                  <Carousels mobileSlideShowTwo={2} pauseOnHover={false} autoplaySpeed={6000} arrows={true}>
                                    {item.data
                                      .filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))
                                      .map((item: any, index: any) => (
                                        <div key={index} className='col-6 col-md-3 card-item'>
                                          <CardV
                                            data={item}
                                            showTitle={true}
                                            showBlurb={false}
                                            showByline={false}
                                            showTime={false}
                                            showCountview={false}
                                            external={false}
                                            //! DATALAYER
                                            eventDataLayer={{
                                              type: DATALAYER_TYPE.TRACK_INDEX,
                                              router: router?.pathname,
                                              section: 'section-3',
                                              data: {
                                                title: item?.title,
                                                heading: `${category?.en}:${subMenu?.sub[i]?.nameEng}`,
                                                index: index + 1
                                              }
                                            }}
                                          />
                                        </div>
                                      ))}
                                  </Carousels>
                                )}
                                {!useMobilePhone() && (
                                  <>
                                    {item.data
                                      .filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))
                                      .map((item: any, index: any) => (
                                        <div key={index} className='col-6 col-md-3 card-item'>
                                          <CardV
                                            data={item}
                                            showTitle={true}
                                            showBlurb={false}
                                            showByline={false}
                                            showTime={false}
                                            showCountview={false}
                                            external={false}
                                            //! DATALAYER
                                            eventDataLayer={{
                                              type: DATALAYER_TYPE.TRACK_INDEX,
                                              router: router?.pathname,
                                              section: 'section-3',
                                              data: {
                                                title: item?.title,
                                                heading: `${category?.en}:${subMenu?.sub[i]?.nameEng}`,
                                                index: index + 1
                                              }
                                            }}
                                          />
                                        </div>
                                      ))}
                                  </>
                                )}
                                <div className='border-bottom' />
                              </div>
                            </li>
                          )}
                        </>
                      ))}
                      {checkDataInsubMenu() === false && (
                        <>
                          {!isEmpty(listArticles) && (
                            <div className='card-list'>
                              <h2>{subCategory?.en ? subCategory?.en : category?.en}</h2>
                              <div className='row'>
                                {listArticles.slice(sliceId).map((item: any, i: any) => (
                                  <div key={i} className='col-6 col-md-3 card-item'>
                                    <CardV
                                      data={item}
                                      showTitle={true}
                                      showBlurb={false}
                                      showByline={false}
                                      showTime={false}
                                      showCountview={false}
                                      external={false}
                                      //! DATALAYER
                                      eventDataLayer={{
                                        type: DATALAYER_TYPE.TRACK_INDEX,
                                        router: router?.pathname,
                                        section: 'section-3',
                                        data: {
                                          title: item?.title,
                                          heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                                          index: i + 1
                                        }
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          {isFetching && <div className='fetching'> กำลังโหลด... </div>}
                        </>
                      )}
                    </ul>
                  </>
                )}
              </>
            ) : (
              <>
                {!isEmpty(listArticles) && (
                  <div className='card-list'>
                    <div className='row'>
                      {listArticles.slice(sliceId).map((item: any, i: any) => (
                        <div key={i} className='col-6 col-md-3 card-item'>
                          <CardV
                            data={item}
                            showTitle={true}
                            showBlurb={false}
                            showByline={false}
                            showTime={false}
                            showCountview={false}
                            external={false}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_INDEX,
                              router: router?.pathname,
                              section: 'section-3',
                              data: {
                                title: item?.title,
                                heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                                index: i + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {isFetching && <div className='fetching'> กำลังโหลด... </div>}
              </>
            )}
          </div>
        </div>
      </CategoryWrapper>
    </>
  );
};

const CategoryWrapper = styled.div`
  .highlight {
    .container {
      padding: 0;
    }
    @media (max-width: 1024px) {
      margin: 0 -15px;
    }
  }
  .title-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      margin-top: 15px;
    }
    a {
      transition: all 0.4s ease-in-out;
      &:hover {
        color: #ed1a3b;
      }
    }
    h2 {
      text-transform: uppercase;
      font-size: 30px;
      font-weight: bold;
      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
    .text-left {
      font-size: 16px;
      padding: 2px 10px;
      background-color: rgb(220 21 53);
      color: #fff;
      border-radius: 8px;
      white-space: nowrap;
      &:hover {
        color: #ed1a3b;
        background-color: rgb(255, 255, 255);
      }
    }
  }
  .meta-data {
    display: none;
  }
  .fetching {
    color: #fff;
  }
  .embed-audio {
    margin: 15px 0;
  }
  h2 {
    color: white;
    font-size: 20px;
    font-weight: 400;
  }
  .breadcrumb-area {
    .breadcrumb {
      li {
        &:not(:last-child) {
          color: #fff !important;
        }
      }
      .breadcrumb-item {
        a {
          color: #fff !important;
        }
      }
    }

    .breadcrumb-title {
      @media (max-width: 480px) {
        padding: 0 0 10px 0;
        border-bottom: 1px solid #ffffff46;
      }
    }
    .category {
      text-transform: uppercase;
      color: #ed1a3b;
      font-size: 40px;
      font-weight: bold;
      display: flex;
      align-items: center;
      @media (max-width: 480px) {
        display: block;
        font-size: 32px;
      }
      h2 {
        padding: 0 0 0 10px;
        &:before {
          content: '●';
          padding: 0 10px 0 0;
          @media (max-width: 480px) {
            content: '';
            padding: 0;
          }
        }
        @media (max-width: 480px) {
          font-size: 16px;
          padding: 0;
        }
      }
    }
  }
  .category-detail {
    padding-bottom: 1px;
    background-color: #000000;
    padding-top: 30px;
  }

  .card {
    &.--content {
      .title {
        color: #ffffff;
      }
    }
  }

  .card-list {
    h2 {
      text-transform: uppercase;
      color: #fff;
      font-weight: bold;
    }
  }

  .submenu-list {
    padding: 0;
    margin: 0;
    width: 100%;
    list-style: none;
    .slick-slider {
      margin: 0 -10px;
      .slick-prev {
        z-index: 1;
        left: 10px;
      }
      .slick-next {
        z-index: 1;
        right: 19px;
      }
    }
    .card-item {
      padding: 0 10px;
    }
    li {
      &:last-child {
        .border-bottom {
          border-bottom: 1px solid transparent;
        }
      }
      p {
        width: fit-content;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: 400;
        color: #fff;
        padding: 10px 0 2px 0;
        @media (max-width: 768px) {
          font-size: 18px;
        }
        @media (max-width: 480px) {
          font-size: 16px;
        }
      }
    }
    .category-list {
      margin: 10px -10px 0px -10px;
      .card-item {
        .card-v {
          .--content {
            h3 {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .crad-video-category-item {
    margin: 30px 0;
  }

  .card-v-category {
    text-transform: uppercase;
    h2 {
      padding: 0 10px;
    }

    .card-v-category-item {
      padding: 0 10px;
      .card-v {
        .--content {
          h3 {
            font-size: 16px;
          }
        }
      }
      @media (max-width: 480px) {
        width: 100% !important;
      }
      &:nth-child(1),
      :nth-child(2) {
        width: 50%;
      }
      &:not(:nth-child(1), :nth-child(2)) {
        width: 33.333%;
      }
    }
  }

  .border-bottom {
    margin: 30px 0;
    border-bottom: 1px solid #ffffffd0;
  }
`;

export default CategoryVideo;
